<template>
  <div
    class="container-comment"
    :key="isRefreshKey"
    :style="
      isInIframe
        ? !isPlayerPause
          ? 'position: fixed; overflow: scroll; top: 0; bottom: 80px; left: 0; right: 0; height: calc(100%); background-color: rgba(0, 0, 0, 0.7); z-index: 10000; padding: 80px 10px 120px 10px; transition: all 0.3s'
          : upHere
          ? 'position: fixed; overflow: scroll; top: 0; bottom: 80px; left: 0; right: 0; height: calc(100%); background-color: rgba(0, 0, 0, 0.7); z-index: 10000; padding: 80px 10px 120px 10px; transition: all 0.3s'
          : 'position: fixed; overflow: scroll; top: 0; bottom: 80px; left: 0; right: 0; height: calc(100%); background-color: rgba(0, 0, 0, 0.7); z-index: 10000; padding: 80px 10px 120px 10px; transition: all 0.3s'
        : isLastClip
        ? 'margin: 7px 0 0 0'
        : ''
    "
  >
    <div v-if="!isLastClip">
      <div no-gutters justify="left" align="left"></div>

      <!-- <v-divider class="mt-6 mb-2 mx-1" style="background-color: #63737d"></v-divider> -->
      <div
        class="helloWorld"
        v-if="commentList !== undefined && commentList !== null && commentList.length > 0"
        :class="currentMt.mtType === 'chronological' ? 'chronological-comment' : ''"
        no-gutters
      >
        <div cols="12" class="py-2 pl-0" v-bind:key="comment.cmId" v-for="(comment, index) in commentList">
          <v-hover v-slot="{ hover }">
            <v-card
              :ref="`vCardComment-${index}`"
              flat
              :elevation="hover ? 2 : 0"
              @click.stop="clickCommentCard(comment)"
              class="commentCard"
              :class="[
                { commentCardClicked: $store.getters.clickCommentId.cmId === comment.cmId },
                { 'hover-comment': hover },
              ]"
              :style="!isInIframe ? '' : 'background-color: rgba(48, 68, 78, 0.8)'"
            >
              <div no-gutters class="wrap-comment">
                <div class="d-flex" style="height: 45px; justify-content: space-between">
                  <div class="d-flex" style="justify-items: center; align-items: center">
                    <v-avatar
                      :color="
                        !comment.userPicture ? comment.userDisplayName || userInfo.userFullName : '' | iconBackground
                      "
                      class="logo"
                      round
                      size="30"
                      style="cursor: default"
                    >
                      <div class="avatar-bg" v-if="comment.userPicture"></div>
                      <span class="white--text cent" style="font-size: 14px" v-if="comment.userPicture === ''">
                        {{ comment.userDisplayName || userInfo.userFullName | iconFilter }}
                      </span>
                      <v-img class="white--text cent" :src="comment.userPicture" size="30" v-else />
                    </v-avatar>

                    <div no-gutters align="start" class="d-flex flex-column pl-2">
                      <div cols="auto" class="">
                        <h5 style="color: white">{{ comment.userDisplayName || userInfo.userFullName }}</h5>
                      </div>
                      <div class="" style="margin-top: -7px">
                        <span style="color: #96a7af; font-size: 11px">
                          {{ $day.duration($day().diff(comment.cmCreatedAt)).humanize().replace('a day', 'Yesterday') }}
                        </span>
                        <span class="ml-1 comment-timestamp">
                          {{ convertSecondsToTime(comment.boxData.time) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" style="justify-items: end">
                    <div v-show="comment.commentMenu" no-gutters align="end" class="dot-comment flex-column">
                      <v-menu v-model="comment.commentMenu" offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn plain v-bind="attrs" v-on="on" style="min-width: 36px">
                            <span
                              style="font-size: 16px; font-weight: 500"
                              class="material-icons-round white--text"
                              translate="no"
                            >
                              {{ comment.commentMenu ? 'close' : 'more_horiz' }}
                            </span>
                          </v-btn>
                        </template>
                        <div class="container-menu-comment" style="background-color: #1d292f; overflow: hidden">
                          <v-row align="center" justify="center" dense>
                            <v-col cols="12">
                              <v-btn dark block class="" color="#eee" plain @click.stop="replyMode(comment)">
                                <span
                                  class="material-icons-round mr-1"
                                  style="color: #ddd; font-size: 18px; font-weight: 400"
                                  translate="no"
                                >
                                  reply
                                </span>
                                Reply
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="
                                currentUser.userId &&
                                currentUser.userId !== null &&
                                currentUser.userId === comment.userId
                              "
                            >
                              <v-btn
                                dark
                                block
                                class=""
                                color="#eee"
                                plain
                                @click.stop="editMode(comment.cmId, comment)"
                                v-if="
                                  currentUser.userId &&
                                  currentUser.userId !== null &&
                                  currentUser.userId === comment.userId
                                "
                              >
                                <span
                                  class="material-icons-round mr-1"
                                  style="color: #ddd; font-size: 18px; font-weight: 400"
                                  translate="no"
                                >
                                  edit
                                </span>
                                Edit
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="isMtOrganizer || isWsOwner || isWsManager || currentUser.userId === comment.userId"
                              style="padding: 0 !important"
                            >
                              <v-divider dark style="display: block"></v-divider>
                            </v-col>
                            <v-col
                              cols="12"
                              v-if="isMtOrganizer || isWsOwner || isWsManager || currentUser.userId === comment.userId"
                            >
                              <v-btn
                                dark
                                block
                                class=""
                                color="#eee"
                                plain
                                @click.stop="deleteC(comment.cmId, comment)"
                              >
                                <span
                                  class="material-icons-round mr-1"
                                  style="color: #ddd; font-size: 18px; font-weight: 400"
                                  translate="no"
                                >
                                  delete
                                </span>
                                Delete
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-menu>
                    </div>
                  </div>
                </div>
                <div no-gutters class="mt-1 ml-10">
                  <div class="textarea-col mb-2">
                    <v-textarea
                      :id="comment.cmId"
                      v-show="!isReply && targetId === comment.cmId"
                      class="pa-0"
                      :background-color="'#475E69'"
                      dense
                      dark
                      solo
                      flat
                      auto-grow
                      rows="1"
                      hide-details
                      v-model="comment.cmContent"
                      :value="comment.cmContent | commentFilter(comment.cmId) | removeHtmlFilter"
                    ></v-textarea>
                    <detail-html
                      v-show="isReply || targetId !== comment.cmId"
                      :cmContent.sync="comment.cmContent"
                      :cmId="comment.cmId"
                    ></detail-html>
                  </div>
                </div>
              </div>
              <div v-if="!isInIframe" no-gutters>
                <div cols="auto" style="width: 32px"></div>
                <div
                  class="container-btn-edit mb-1 d-flex justify-end"
                  cols="auto"
                  v-if="isEdit && targetId === comment.cmId"
                >
                  <v-btn text color="#ccc" dark class="cancel_btn px-2" elevation="0" @click.stop="cancel()">
                    <span
                      class="material-icons-round mr-1"
                      style="color: #bbb; font-size: 18px; font-weight: 400"
                      translate="no"
                    >
                      highlight_off
                    </span>
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    text
                    dark
                    color="#ccc"
                    class="ml-1 save_btn"
                    :loading="isSaveEditLoading"
                    @click.stop="saveReply(comment)"
                  >
                    <span
                      class="material-icons-round mr-1"
                      style="color: #bbb; font-size: 18px; font-weight: 400"
                      translate="no"
                    >
                      check_circle_outline
                    </span>
                    {{ $t('save') }}
                  </v-btn>
                </div>
                <div v-else cols="auto" class="comment_btn_col d-flex justify-start ml-9 mb-0"></div>
              </div>
              <div v-if="isReply && targetId === comment.cmId" class="mt-4">
                <div no-gutters>
                  <div cols="auto" style="width: 44px"></div>
                  <div class="textarea-col">
                    <v-textarea
                      @keydown.enter="onEnterPress($event, replyComment, saveReply)"
                      @click="stopEventBubbling($event, comment)"
                      prepend-icon="mdi-arrow-right-bottom"
                      ref="txta_reply"
                      class="pa-0 ml-2"
                      background-color="#475E69"
                      solo
                      color="#96a7af"
                      dense
                      dark
                      flat
                      rows="1"
                      hide-details
                      auto-grow
                      v-model="replyComment.cmContent"
                    ></v-textarea>
                  </div>
                </div>
                <div align="center" justify="space-between" no-gutters class="d-flex flex-nowrap mt-2">
                  <div style="width: 38px" cols="auto" />
                  <div cols="auto">
                    <!-- <a class="a-timestamp" @click.stop="setTimeStamp(replyComment, true)">
                    {{ 'Add a timestamp' }} -->
                    <!-- <v-icon color="#96a7af" class="btn-icon mr-2 pointer">mdi-clock-outline</v-icon> -->
                    <!-- </a> -->
                  </div>
                  <v-spacer />
                  <div class="container-btn-reply mb-1" cols="auto">
                    <v-btn
                      text
                      color="#ccc"
                      dark
                      class="px-2 cancel_btn"
                      style="background-color: transparent"
                      elevation="0"
                      @click.stop="cancel()"
                    >
                      <span
                        class="material-icons-round mr-1"
                        style="color: #bbb; font-size: 18px; font-weight: 400"
                        translate="no"
                      >
                        highlight_off
                      </span>
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      text
                      color="#ccc"
                      dark
                      elevation="0"
                      :loading="isSaveReplyLoading"
                      @click.stop="postComment(replyComment)"
                    >
                      <span
                        class="material-icons-round mr-1"
                        style="color: #bbb; font-size: 18px; font-weight: 400"
                        translate="no"
                      >
                        check_circle_outline
                      </span>
                      {{ $t('post') }}
                    </v-btn>
                  </div>
                </div>
              </div>

              <detail-reply
                ref="reply"
                :targetId.sync="targetId"
                :replyCount.sync="comment.childCmCount"
                @saveReply="saveReply"
                :parentId.sync="comment.cmId"
              ></detail-reply>
            </v-card>
          </v-hover>
        </div>
      </div>
      <v-row
        v-if="isCommentListLoading"
        no-gutters
        justify="center"
        align="center"
        class="mt-2 mr-5"
        style="overflow-y: hidden"
      >
        <v-skeleton-loader width="650" type="list-item-three-line" dark flat></v-skeleton-loader>
      </v-row>
    </div>
    <confirm-modal
      :title="$t('deleteComment')"
      ref="confirm"
      :isVisible.sync="isVisible"
      :message="$t('cannotUndoneMsg')"
      :cancelLabel="$t('cancel')"
      :confirmLabel="$t('confirm')"
    ></confirm-modal>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </div>
</template>

<script>
import { numFormat, time } from '@/common/lib/strLib'
import {
  getCommentList,
  getPublicCommentList,
  createComment,
  deleteComment,
  updateComment,
} from '@/services/commentApi'
import Toast from '@/views/meeting/component/Toast'
import DetailReply from '@/views/meeting/component/detail/DetailReply'
import ConfirmModal from '@/views/modal/ConfirmModal'
import DetailHtml from '@/views/meeting/component/detail/DetailHtml'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters, mapState } from 'vuex'
import GuestIn from '@/views/modal/GuestIn'
// import { nextTick } from 'process'
// import { timeToSecond } from '@/common/lib/strLib'
// import { sendDataWithEnter } from '@/common/common'
// import Attendee from '@/views/meeting/component/card/Attendee'

export default {
  name: 'DetailComment',
  components: { DetailHtml, ConfirmModal, DetailReply, GuestIn },
  //Component 변수
  props: ['upHere', { currentTime: Number }, 'tabIndex'],
  created() {
    // this.getCommentList(false)
    this.$root.$refs[`DetailComment-${this.sectionIndex}`] = this
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.scrollCheck)
  },
  mounted() {
    // console.log(this.tabIndex)
  },
  updated() {},
  unmounted() {
    let element = document.getElementsByClassName('container-comment')[0]
    element.style.height = '0'
  },

  data() {
    return {
      isRefreshKey: false,
      targetId: '',
      editContent: '',
      isEdit: false,
      isReply: false,
      isShowReply: false,
      isVisible: false,
      timestampList: [],
      replyList: [],
      // comment: {
      //   cmContent: '',
      //   cntComment: '',
      // },
      editCommentContent: '',
      replyComment: {
        cmContent: '',
        cmId: '',
      },
      isSaveReplyLoading: false,
      isSaveEditLoading: false,
      // isSaveCommentLoading: false,
      // lastKey: null,
      // isBottom: false,
      // isFinish: false,
      drawer: true,
      mini: false,
      isBoxCommentData: false,
      // boxCommentList: [],
      isCommentCardClicked: false,
      isInputBoxClicked: false,
      lastClip: this.$store.getters.isLastClip,
      isCommentListLoading: false,
      isPostingComment: false,
      guestInActionType: '',
      guestInVisible: false,
      parentCommentData: '',
    }
  },
  methods: {
    convertSecondsToTime(time) {
      var hours = Math.floor(time / 3600)
      var minutes = Math.floor((time - hours * 3600) / 60)
      var seconds = Math.floor(time - hours * 3600 - minutes * 60)

      // 1시간 이상일 때
      if (hours > 0) {
        return (
          (hours < 10 ? '0' + hours : hours) +
          ':' +
          (minutes < 10 ? '0' + minutes : minutes) +
          ':' +
          (seconds < 10 ? '0' + seconds : seconds)
        )
      }
      // 1시간 미만일 때
      else {
        return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      }
    },
    commentAsGuest(comment) {
      if (this.detailCommentInputComponent) {
        this.detailCommentInputComponent.postComment(comment)
      }
    },

    closeGuestIn() {
      this.guestInVisible = false
      if (this.currentUser && !isEmptyObject(this.currentUser)) {
        this.postComment(this.guestInActionType)
      }
      function isEmptyObject(param) {
        return Object.keys(param).length === 0 && param.constructor === Object
      }
    },

    postComment(comment) {
      if (
        this.chkMtPublic &&
        this.chkMtPublic['isPublic'] &&
        (!this.currentUser.userId || this.currentUser.userId === null)
      ) {
        this.guestInActionType = comment
        this.guestInVisible = true
        // this.commentAsGuest(comment)
      } else {
        this.saveReply(comment)
      }
    },

    stopEventBubbling(e) {
      if (this.isMobile) {
        e.stopPropagation()
      }

      // else {
      //   this.$store.dispatch('setIsFadeOut', false)
      //   if (!this.$store.getters.clickCommentId || this.$store.getters.clickCommentId === {}) {
      //     this.$store.dispatch('setClickcmId', comment)
      //   } else {
      //     this.$store.dispatch('setClickcmId', false)
      //   }
      // }
    },

    scrollToHighlightedComment(index, behavior) {
      //선택 된 커멘트 스크롤 이벤트 하는 메소드
      if (this.isMobile) return
      // index값만 제대로 주면 딱 스크롤 이벤트 발생
      // 왜 옵셔널 체이닝을 해야지만 작동 하는지??
      if (!this.$refs[`vCardComment-${index}`][0]) return
      let el = this.$refs[`vCardComment-${index}`][0].$el

      if (el && el !== null && el !== undefined) {
        el.scrollIntoView({ behavior })
      }
    },

    onEnterPress(e, comment) {
      if (this.isPostingComment) return
      if (e.which === 13 && !e.shiftKey) {
        e.preventDefault()
        if (
          this.chkMtPublic &&
          this.chkMtPublic['isPublic'] &&
          (!this.currentUser.userId || this.currentUser.userId === null)
        ) {
          this.postComment(comment)
        } else {
          this.saveReply(comment)
        }
      }
    },
    // onEnterPress(e, args, callbackFnc) {
    //   if (this.isPostingComment) return
    //   sendDataWithEnter(e, args, callbackFnc)
    // },

    async setCommentList(val) {
      //댓글 리스트를 받아서 댓글 리스트를 업데이트 하는 메소드
      await this.$store.dispatch('setCommentList', val)
    },

    scrollCommentCardMobile(comment, commentList) {
      commentList.forEach((item, index) => {
        if (item.cmId === comment.cmId && this.isMobile) {
          window.scrollTo({
            top: this.$refs[`vCardComment-${index}`][0].$el.offsetTop - 334,

            behavior: 'smooth',
          })
        }
      })
    },

    clickCommentCardUnified(comment) {
      //댓글 카드 클릭 이벤트
      if (!comment.boxData.width) {
        this.boxCommentComponent.removeBox()
      }

      // console.log(comment.boxData.time)

      this.$store.dispatch('setCommentPlayOn', false)
      if (comment.boxData.time > 0) {
        let time = comment.boxData.time * 1000
        this.setSeekTime(time)
      } else {
        this.setSeekTime(0.062)
        // this.setSeekTime(comment.boxData.time)
      }

      if (this.boxCommentComponent) this.boxCommentComponent.handleCommentClickEvent(comment)
      this.$store.dispatch('setClickcmId', comment)
      this.$store.dispatch('setIsFadeOut', false)

      if (this.$store.getters.boxDrawn) {
        this.$store.dispatch('setBoxDrawn', false)
      }

      if (this.boxCommentComponent) this.boxCommentComponent.onCommentRandomAccess(comment.boxData.time)
      // if (this.boxCommentComponent) this.boxCommentComponent.addToDisplayingCommentList(comment)
    },

    clickCommentCard(comment) {
      //댓글 카드 클릭 이벤트
      clearTimeout(this.$store.getters.removeCommentPlayTimeOut)

      this.clickCommentCardUnified(comment)
    },

    setSeekTime(event) {
      this.$store.dispatch('setTimeStampSeekTime', event / 1000)
      this.$store.dispatch('setIsRequestSetSeekTime', true)

      // 옛날엔 영상을 보기 위해 최상단으로 스크롤 이동 했지만 현재 영상 고정으로 필요없음
      // if (window.innerWidth <= 1263) {
      //   setTimeout(() => {
      //     window.scrollTo({
      //       top: 0,
      //       left: 0,
      //       behavior: 'smooth',
      //     })
      //   }, 10)
      // }
    },
    /**
     * 등록, 수정, 삭제 등 처리 후엔 초기화 후 호출
     * 이슈 없을 것 같아 Infinity Loading 제거..
     * @param isInfinityCall 주석처리
     */
    async getCommentList(val) {
      // if (!isInfinityCall) {
      //   this.lastKey = null
      //   this.isBottom = false
      //   this.isFinish = false
      // }

      try {
        if (val !== 'delete') this.isCommentListLoading = true
        let result =
          this.chkMtPublic && this.chkMtPublic['isPublic']
            ? await getPublicCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, undefined)
            : await getCommentList(this, this.currentMt.mtId, this.currentClip.clipId, undefined, undefined)

        this.$store.dispatch('setControlbarIconList', result.boxCommentList)

        if (result !== undefined && result !== null) {
          this.setCommentList([])
          let list = this.$store.getters.commentList
          // if (!isInfinityCall) this.setCommentList([])
          for (let comment of this.commentList) {
            list.push(comment)
          }

          this.setCommentList(list.concat(result.list))
          // this.commentList = this.commentList.concat(result.list)
          // if (result.lastKey && result.lastKey !== null) this.lastKey = result.lastKey
          // else {
          //   this.lastKey = null
          // }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$nextTick(() => {
          if (this.boxCommentComponent) {
            this.boxCommentComponent.filteredComments = this.controlbarIconList ? [...this.controlbarIconList] : []
          }
        })
        this.$emit('commentsLength', this.commentList.length)
        this.isCommentListLoading = false
      }
    },

    async setTimeStamp(comment, isReply) {
      let textArea = isReply
        ? this.$refs.txta_reply[0].$el.querySelector('textarea')
        : this.$refs.txta_comment.$el.querySelector('textarea')
      let cursorStart = textArea.selectionStart
      let startTxt = comment.cmContent.substring(0, cursorStart)
      let endTxt = comment.cmContent.substring(cursorStart, comment.cmContent.length)

      let sectionContents = this.currentMt.mtType === 'topic' ? numFormat(Number(this.sectionIndex) + 1) + '-' : ''

      comment.cmContent =
        startTxt +
        '[Clip#' +
        sectionContents +
        numFormat(
          this.currentMt.mtType === 'chronological' ? Number(this.sectionIndex) + 1 : Number(this.clipIndex) + 1
        ) +
        ' ' +
        time(this.seekTime) +
        ']' +
        endTxt
    },
    init() {
      this.comment.cmContent = ''
    },
    async saveReply(comment) {
      //isReply모드가 아니고 박스가 그려졌으면 saveReply 버튼을 누를 때 인풋창 스타일링 제거
      if (!this.isReply && this.boxDrawn) {
        this.$store.dispatch('setBoxDrawn', false)
      }

      if (this.isReply) {
        if (comment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')

          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        this.isSaveReplyLoading = true

        await this.doSave(comment)
      } else if (this.isEdit) {
        if (comment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')

          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        this.isSaveEditLoading = true
        comment.cmContent = document.getElementById(comment.cmId).value
        await this.doSave(comment)
      } else {
        if (comment.cmContent === '') {
          // notify(this, 'Error', 'Content is Empty', 'error')

          const content = {
            component: Toast,
            props: {
              msg: 'Content is Empty',
              // submsg: '',
            },
          }
          this.$toast.error(content)
          return
        }
        // this.isSaveCommentLoading = true
        // this.detailCommentInputComponent.saveCommentLoading(true)
        await this.doSave(comment)
      }
    },
    async doSave(comment) {
      let content = comment.cmContent
      try {
        if (this.isEdit) {
          await updateComment(this, this.currentMt.mtId, comment.cmId, content, comment.cmContent)
        } else {
          let time

          if (this.isReply) {
            time = this.parentCommentData
          } else {
            time = this.$store.getters.seekTimeDecimal
          }
          let boxData
          if (this.boxCommentComponent) {
            boxData =
              this.boxCommentComponent.getBoxData(time) &&
              this.boxCommentComponent.getBoxData(time) !== undefined &&
              this.boxCommentComponent.getBoxData(time) !== null
                ? this.boxCommentComponent.getBoxData(time)
                : this.boxCommentComponent.getTimeOnlyCommentData(this.isReply, this.parentCommentData)
          }

          await createComment(
            this,
            this.currentMt.mtId,
            this.currentClip.clipId,
            comment.parentId,
            content,
            comment.cmContent,
            boxData
            // this.$store.getters.boxCommentData && this.$store.getters.boxCommentData !== null
            //   ? this.$store.getters.boxCommentData
            //   : undefined
          )
          this.$store.dispatch('setFirebaseLog', {
            eventName: 'create_comment',
            eventParam: {
              name: 'create_comment',
            },
          })

          // Inbox 채널일 경우 클립 생성 로그 추가
          if (this.selectedCh && this.selectedCh['chCategory'] === 'inbox') {
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'inbox_create_comment',
              eventParam: {
                name: 'inbox_create_comment',
              },
            })
          }
          this.$store.dispatch('setBoxCommentData', null)
          if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
          this.isPostingComment = true
        }

        this.cancel()
      } catch (e) {
        console.log(e)
      } finally {
        this.getCommentList(false)
        this.isSaveEditLoading = false
        this.isSaveReplyLoading = false
        this.isPostingComment = false
        // await this.$store.dispatch('setIsLoading', false)
        // this.isSaveCommentLoading = false
        // if (this.detailCommentInputComponent) this.detailCommentInputComponent.emptyCommentInput()
        // this.detailCommentInputComponent.saveCommentLoading(false)
      }
    },
    editMode(id, comment) {
      this.targetId = id
      this.isEdit = true
      this.isReply = false
      comment.commentMenu = false
    },
    replyMode(comment) {
      this.targetId = comment.cmId
      this.isReply = true
      this.isEdit = false
      this.replyComment.parentId = comment.cmId
      this.parentCommentData = comment.boxData.time
      comment.commentMenu = false
    },
    cancel() {
      this.targetId = ''
      this.isReply = false
      this.isEdit = false
      this.comment = { cmContent: '' }
      this.replyComment = { cmContent: '', cmId: '' }
    },
    async deleteC(id, comment) {
      this.isVisible = true
      comment.commentMenu = false
      // this.$refs.confirm
      //   .show()
      //   .then(() => {
      //     this.doDelete(id)
      //   })
      //   .catch(() => {
      //     // alert('You rejected')
      //   })
      this.doDelete(id)
    },
    async doDelete(id) {
      try {
        await deleteComment(this, this.currentMt.mtId, id)
      } catch (e) {
        console.log(e)
      } finally {
        this.$refs.confirm.updateVisible(false)
        this.getCommentList('delete')
        if (this.boxCommentComponent) this.boxCommentComponent.removeBox()
        // notify(this, 'Success', 'Delete success', 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteCommentSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
      }
    },
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
  },
  computed: {
    ...mapGetters([
      'isMtOrganizer',
      'isWsOwner',
      'isWsManager',
      'commentList',
      'sectionIndex',
      'seekTime',
      'clipIndex',
      'clipList',
      'chkMtPublic',
      'totalSectionList',
      'controlbarIconList',
      'currentClip',
      'currentMt',
      'boxDrawn',
      'selectedCh',
    ]),

    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
      isPlayerPause: (state) => {
        return state.clip.isPlayerPause
      },
    }),
    detailCommentInputComponent() {
      return this.$root.$refs[`DetailCommentInput-${this.sectionIndex}`]
    },
    boxCommentComponent() {
      return this.$root.$refs[`BoxComment-${this.sectionIndex}`]
    },
    commentPlayComponent() {
      return this.$root.$refs[`CommentPlay-${this.sectionIndex}`]
    },
    currentUser() {
      let user = this.$store.getters.userInfo
      return user && user !== null ? user : {}
    },
    isSectionMt() {
      return this.currentMt.sectionInfo && this.currentMt.sectionInfo !== null && this.currentMt.sectionInfo.length > 0
    },
    isMobile() {
      return isMobile()
      // return true
    },
    isLastClip() {
      return (
        this.clipList &&
        this.clipList !== null &&
        this.clipList.length > 0 &&
        this.$store.getters.isLastClip &&
        this.$store.getters.isLastClip !== null
      )
    },
    isFeedback: (state) => {
      return state.clip.isFeedback
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
  },
  watch: {
    currentMt() {
      this.$store.dispatch('setControlbarIconList', null)
      this.setCommentList(null)
      this.getCommentList(false)
    },
    // 섹션 삭제 감지를 위해 추가
    totalSectionList: {
      deep: true,
      immediate: true,
      handler() {
        this.isRefreshKey = !this.isRefreshKey
      },
    },
    currentClip: {
      deep: true,
      immediate: true,
      handler(oldVal, newVal) {
        //currentClip의 Object가 request나 screen이 거의 똑같아서 deep: true를 해줘야 currentClip 변화 감지.
        if ((oldVal?.clipId !== newVal?.clipId && oldVal !== undefined) || newVal === undefined) {
          this.$store.dispatch('setControlbarIconList', null)
          this.setCommentList(null)
          this.getCommentList(false)
          this.$store.dispatch('setEmoticonList', null)
          // if (this.boxCommentComponent) this.boxCommentComponent.filteredComments = this.controlbarIconList
          if (this.boxCommentComponent) this.boxCommentComponent.initComments()
          if (this.boxCommentComponent) this.boxCommentComponent.getEmojiList()
        }
      },
    },
  },
}
</script>

<style scoped>
.commentCard {
  background-color: #30444e;
  border-radius: 5px;
  padding: 8px 12px 2px 12px;
  border: 1px solid transparent;
  transition: all 0.3s;
}
.commentCard:hover {
  border: 1px solid rgba(255, 255, 255, 0.3);
  /* transform: translate(0, -2px); */
  /* transform: translate3d(-5px, -5px); */
  transition: all 0.3s;
}
.commentCard:hover .comment-timestamp {
  display: inline-flex !important;
  opacity: 1;
  transition: opacity 0.3s;
}

.commentCardClicked,
.commentCardClicked:focus-within {
  border: 1px solid rgb(29, 41, 47);
  box-shadow: 0px 0px 0px 1px #ff575f !important;
}

.commentInputBox {
  display: flex;
  border: 2px solid transparent;
  background: rgb(71, 94, 105);
  border-radius: 12px;
  width: 100%;
  transition: border 0.3s;
}

/* .commentInputBox:focus {
  outline: #ff575f solid 5px;
  animation: pulse 2s infinite;
} */

.commentInputBoxClicked {
  /* outline: #ff575f solid 5px; */
  border: 2px solid #ff575f;
  animation: pulse 2s infinite;
  /* 이거를 border 대신에 outline으로 하면 움직이는거 안하고 보더 스타일링 가능 */
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 87, 95, 0.8);
  }
  70% {
    box-shadow: 0 0 0 13px rgba(255, 87, 95, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 87, 95, 0);
  }
}

.commentInputBox .Add {
  outline: none;
}

.commentInputBox .textField {
  width: 100%;
}

.textBox {
  resize: none;
  width: 100%;
  color: #fff;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 10px 0 0 10px;
  font-size: 14px;
}

.textBox >>> .v-input__control {
  min-height: 30px !important;
}

.textBox >>> textarea::placeholder {
  font-size: 12px;
}
.textarea-col >>> textarea {
  padding-left: 5px !important;
}
.textarea-col >>> .v-input {
  font-size: 13px;
  font-weight: normal;
}

.textarea-col >>> i {
  font-size: 17px;
  color: #999;
}

.commentInputBox .PublishBtn {
  display: flex;
  justify-content: flex-end;
  align-items: end;
  background-color: #475e69;
  border-radius: 0 10px 10px 0;
}

.commentInputBoxInside {
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.crown {
  color: #ffc542;
  font-size: 15px;
  position: relative;
  transform: translate(0px, -45px);
}
.v-avatar {
  border: 2px solid #30444e !important;
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
.logo label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.logo label:hover {
  border-bottom: 1px solid #666;
}

.logo input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.logo img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}

.v-text-field--outlined >>> fieldset {
  border-color: transparent;
}

.textarea-col >>> .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  padding-left: 5px;
}

.textarea-col >>> .v-text-field__slot textarea {
  color: #ffffff !important;
  line-height: 25px !important;
}

.save_btn {
  font-size: 12px;
}

.cancel_btn {
  background-color: transparent !important;
  font-size: 11px;
}

.comment_btn {
  background-color: transparent !important;
  font-size: 12px;
  padding-left: 0;
  padding-right: 0;
  width: 50px !important;
}

.comment_btn_col >>> .v-btn:not(.v-btn--round).v-size--default {
  min-width: 50px !important;
}

.a-timestamp {
  font-size: 14px;
  display: inline;
  padding-left: 8px;
  padding-right: 8px;
}
.v-app-bar__nav-icon >>> .v-btn__content {
  text-align: start;
}
.container-comment {
  scroll-behavior: smooth;
  display: block;
  /* padding: 0 15px 0 0; */
  height: 100%;
  min-height: 100%;
  transition: padding 0.3s;

  /* margin-bottom: -12px; */
}
.chronological-comment {
  /* padding-right: 20px; */
  /* max-height: calc(100vh - 420px); */
  overflow-y: scroll;
  overflow-x: hidden;
}

@media (max-width: 959px) {
  .container-comment {
    margin-bottom: 5px;
    padding: 0;
  }
}
.v-skeleton-loader >>> .v-skeleton-loader__list-item-three-line {
  background-color: transparent;
}
.container-menu-comment {
  width: 200px;
  padding: 4px;
  border-radius: 5px;
  border: 1px solid #475e69;
}
.container-menu-comment >>> .row--dense > .col {
  padding: 4px !important;
}
/* .container-menu-comment >>> .row--dense > .col {
  padding: 0 !important;
} */
.container-menu-comment >>> button span {
  font-size: 13px;
  font-weight: 400;
}

.container-menu-comment >>> button {
  width: 192px;
  justify-content: start;
}
.container-menu-comment >>> button:hover {
  /* border: 1px solid #666; */
  background-color: #161d21;
}
.container-btn-edit >>> button span,
.container-btn-reply >>> button span {
  font-size: 12px;
  font-weight: 400;
}
.wrap-comment:hover .dot-comment {
  display: inline-flex !important;
}
.comment-timestamp {
  opacity: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(26, 39, 46, 0.4);
  padding: 2px 4px;
  border-radius: 3px;
  color: #ccc;
  font-size: 11px;
  transition: opacity 0.3s;
}
</style>
